import React from 'react';
import InsuredPersonPopUpForm from './InsuredPersonPopUpForm';
import BeneficiaryPersonPopUpForm from './BeneficiaryPersonPopUpForm';
import { IPersonWidgetInfo } from '..';

interface IPolicyPersonPopUpProps {
  lineExternalCode: string;
  section: string;
  maxInsured: number;
  data: IPersonWidgetInfo[];
  lovs: Record<string, Record<string, string>>;
  onClose: () => void;
  onSuccess: () => void;
}

const PolicyPersonPopUp: React.FC<IPolicyPersonPopUpProps> = ({
  lineExternalCode,
  section,
  maxInsured,
  data,
  lovs,
  onClose,
  onSuccess,
}) => {
  return section === 'insured' ? (
    <InsuredPersonPopUpForm
      lineExternalCode={lineExternalCode}
      data={data}
      lovs={lovs}
      maxInsured={maxInsured}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  ) : (
    <BeneficiaryPersonPopUpForm
      lineExternalCode={lineExternalCode}
      data={data}
      lovs={lovs}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};

export default PolicyPersonPopUp;
